import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-chevron-down-svg-icon',
  imports: [NgClass],
  templateUrl: './ln-chevron-down-svg-icon.component.html',
  styleUrl: './ln-chevron-down-svg-icon.component.css',
})
export class LnChevronDownSvgIconComponent {
  @Input({ required: true }) class!: string;
  @Input() fillColor = '#577778';
}
